import { useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useAddManualStockExchangeMutation } from '@api/stock-exchange-settings';
import { ExchangeSetting } from '@g17eco/types/stock-exchange-settings';
import { toastFromError } from '@g17eco/molecules/toasts';

interface AddStockExchangeModalProps {
  isOpen: boolean;
  handleClose: () => void;
  initiativeId: string;
  onSaved: (stockExchange: ExchangeSetting) => void;
}

export const AddStockExchangeModal = (props: AddStockExchangeModalProps) => {
  const { isOpen, handleClose, initiativeId, onSaved } = props;
  const [name, setName] = useState('');
  const [addManualStockExchange, { isLoading }] = useAddManualStockExchangeMutation();

  const handleSave = async () => {
    if (!name.trim()) {
      return;
    }

    try {
      const data = await addManualStockExchange({ initiativeId, name: name.trim() }).unwrap();
      const added = data.find((item) => item.name === name.trim());
      if (added) {
        onSaved(added);
      }
      setName('');
      handleClose();
    } catch (err) {
      toastFromError({ error: err, title: 'Failed to add stock exchange' });
    }
  };

  const handleModalClose = () => {
    setName('');
    handleClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} backdrop='static'>
      <ModalHeader toggle={handleModalClose}>Add stock exchange</ModalHeader>
      <ModalBody>
        <Input
          name='name'
          className='w-100 text-md'
          placeholder='Enter stock exchange name'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </ModalBody>
      <ModalFooter className='pt-0'>
        <Button color='link-secondary' className='mr-3' onClick={handleModalClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSave} disabled={isLoading || !name.trim()}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
